import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import { ContentType, DocumentType } from "@/src/utils/enum";
import { Article } from "@/lib/types/Article";
import { Employee } from "@/lib/types/Employee";
import { Opinion } from "@/lib/types/Opinion";
import { Document } from "@/lib/types/Document";
import { Slider } from "@/lib/types/Slider";
import PageHead from "@/src/shared/PageHead";
import MobileMenu from "@/src/shared/Header/subs/MainHeader/MobileMenu";
import Header from "@/src/shared/Header/Header";
import BackToTop from "@/src/shared/BackToTop";
import Separator from "@/src/shared/Separator";
import Footer from "@/src/shared/Footer";
import HomePage from "@/src/features/home/HomePage";
import HomePageContext, { IHomePageContext } from "@/src/features/home/HomePageContext";
import API from "@/lib/api";

export default function Index({ page }: { page: IHomePageContext }) {
  return (
    <HomePageContext.Provider value={page}>
      <PageHead />
      <MobileMenu />
      <Header />
      <HomePage />
      <BackToTop />
      <Separator />
      <Footer />
    </HomePageContext.Provider>
  );
}

export const getServerSideProps = sharedServerSideProps(async () => {
  const [announcements, articles, employees, opinions, documents, sliders] = await Promise.all([
    API.Client.get<Article[]>("/api/article/list", {
      params: { Skip: 0, Take: 4, "Filters[ContentType]": ContentType.Announcement }
    }),
    API.Client.get<Article[]>("/api/article/list", {
      params: { Skip: 0, Take: 3, "Filters[ContentType]": ContentType.News }
    }),
    API.Client.get<Employee[]>("/api/employee/list", {
      params: { Skip: 0, Take: 6, "Filters[IsActive]": true, OrderBy: "DisplayOrder", OrderByAscending: true }
    }),
    API.Client.get<Opinion[]>("/api/opinion/list", {
      params: { Skip: 0, Take: 30 }
    }),
    API.Client.get<Document[]>("/api/document/list", {
      params: { Skip: 0, Take: 6, "Filters[DocumentType]": DocumentType.None, ClearCache: true }
    }),
    API.Client.get<Slider[]>("/api/slider/list")
  ]);

  return {
    page: { announcements, articles, employees, opinions, documents, sliders }
  };
});
